import http from '../../http';

export const getListForSelect = (claveEstado) => {
    return (dispatch, getState) => {
        var config = { headers: { 'Content-Type': 'application/json' } };
      
        http.get(`catalogomunicipios/listadoselect/${claveEstado}`, config)        
            .then(function (response) {
                dispatch({
                    type: "CATALOGO_MUNICIPIOS_LIST_SELECT", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(error => {
                var errorMessage = "";
                if (error.response) {
                    errorMessage = error.response.data.mensaje;
                } else {
                    errorMessage = `No se obtuvo respuesta del servidor ${error}`;
                }
                dispatch({ type: 'CATALOGO_MUNICIPIOS_ERROR', payload: { error: errorMessage } });
            })
            .finally(function () {
                
            }); 
    }
}

export const clearMessages = () => {
    return (dispatch, getState) => {
        dispatch({type: "CATALOGO_MUNICIPIOS_LIMPIAR_MENSAJES"});
    }
}